module.exports = __webpack_public_path__ + "img/7.fa38a114.svg";